<template>
   <a v-if="to && isExternalLink" :href="to" class="btn" :class="computedClasses">{{ label }}</a>
   <NuxtLink v-else-if="to" :to="to" class="btn" :class="computedClasses">{{ label }}</NuxtLink>
   <button v-else class="btn" :class="computedClasses">{{ label }}</button>
</template>

<script setup lang='ts'>
/*  IMPORTS  */

/*  VARIABLES  */
const props = defineProps<{
    label: string
    center?: boolean
    to?: string
    animation?: string
    spaceBlock?: boolean
}>()

/*  FUNCTIONS  */
const isExternalLink = computed(() => {
    if (!props.to) return false
    return props.to.startsWith('http') || 
           props.to.startsWith('mailto:') || 
           props.to.startsWith('tel:') ||
           props.to.startsWith('#')
})

    
const computedClasses = computed(() => ({
    'btn-center': props.center,
    [props.animation as string]: !!props.animation,
    'space-block': props.spaceBlock,
}))
</script>

<style lang="scss">
    .btn{
        font-size: 20px;
        font-family: 'Open Sans',sans-serif;
        padding: 10px 20px;
        color: $white;
        background-color: $violet;
        border-radius: 50px;
        border:2px solid $violet;
        cursor: pointer;
        width: fit-content;
        text-decoration: none;
        transition: all .2s;
        @media screen and (max-width:1035px) {
            font-size: 16px;
        }
        &:hover{
            background-color: #fff;
            color: #9152F7;
        }
        &-center{
            display: block;
            margin: auto;
        }
        &.space-block{
            margin-block: 20px;
        }
    }
</style>